import SoyuzAnalytics, { createInstance } from '@spotahome/soyuz-analytics';

export const InstanceManager = {
  getClientSideInstance() {
    return SoyuzAnalytics;
  },
  getServerSideInstance() {
    return createInstance();
  },
  flush(instance) {
    return instance.flush();
  }
};
